
import Vue from 'vue'
import { productMeta } from './product-meta'

interface GameCard {
  id: string
  category?: string
  title: string
  status: string
  statusType: 'active' | 'queue' | 'prep'
  platform: string
  description: string
  signals: string[]
  imageSrc?: string
  imageAlt?: string
  imageWidth?: number
  imageHeight?: number
  url?: string
  investorUrl?: string
}

export default Vue.extend({
  name: 'GamesPage',
  metaInfo () { return productMeta('Games & Apps | ARI.company', 'Explore ARI.company games and apps, with current availability and product information.', '/games/moonday/release-1/social.jpg') },

  data () {
    return {
      games: [
        {
          id: 'apple-hunter',
          title: 'Apple Hunter',
          status: 'Published',
          statusType: 'active',
          platform: 'Mobile',
          description: 'Apple Hunter is now live on Google Play with active post-launch support and optimisation.',
          signals: ['Published on Google Play', 'Live update cycle active', 'Performance monitoring in place'],
          imageSrc: '/android/apple-hunter/assets/apple-hunter-logo-games.webp',
          imageAlt: 'Apple Hunter logo',
          url: '/android/apple-hunter'
        },
        {
          id: 'tok-kids',
          title: 'Tok.Kids',
          status: 'Live',
          statusType: 'active',
          platform: 'Web',
          description: 'A child-friendly typing adventure where children practise letters, words, speed, and accuracy through fantasy missions, rewards, and progress.',
          signals: ['Educational typing adventure', 'Designed for children aged 7+', 'Letters, words, speed and accuracy practice'],
          imageSrc: '/games/tok-kids/assets/tok-kids-games.webp',
          imageAlt: 'Child adventurer with a fox and green creature in the Tok.Kids fantasy world',
          imageWidth: 1200,
          imageHeight: 630,
          url: '/games/tok-kids'
        },
        {
          id: 'orbit-rush',
          title: 'LODOMELIX',
          status: 'In Testing',
          statusType: 'queue',
          platform: 'Mobile',
          description: 'A fantasy hero RPG: collect heroes, develop their equipment and skills, and challenge tower bosses. Android release in testing.',
          signals: ['Hero collection and equipment', 'Auto-battles, tower bosses and raids', 'No public release date confirmed'],
          imageSrc: '/games/ludomelix/release-1/social.jpg',
          imageAlt: 'LODOMELIX original hero artwork with Kael, Frost Warden and Aurelion',
          url: '/games/ludomelix',
          investorUrl: '/contact?lead=investor&project=ludomelix&budget=top'
        },
        {
          id: 'lord-of-apples',
          title: 'Lord of Apples',
          status: 'In Concept Production',
          statusType: 'queue',
          platform: 'Mobile + Web',
          description: 'Educational adventure game where players solve maths challenges, progress heroes, and clear staged boss encounters. The project is currently in search of an investor.',
          signals: ['Math challenge architecture', 'Hero class balancing', 'Boss and reward loop prototyping', 'Investor search active'],
          imageSrc: '/games/lord-of-apples/assets/logo-lord-of-apples-games.webp',
          imageAlt: 'Lord of Apples logo',
          url: '/games/lord-of-apples',
          investorUrl: '/contact?lead=investor&project=lord-of-apples&budget=top'
        },
        {
          id: 'moonday', title: 'MoonDay', category: 'App',
          status: 'Internal testing', statusType: 'queue', platform: 'Android',
          description: 'A personal diary for periods and intimacy, with a calendar, recorded history and encrypted local storage.',
          signals: ['Choose what you track', 'Adults 18+ · English and Ukrainian', 'No public download yet'],
          imageSrc: '/games/moonday/release-1/social.jpg',
          imageAlt: 'MoonDay icon and actual calendar screen with fictional sample entries',
          imageWidth: 1200, imageHeight: 630, url: '/games/moonday'
        }
      ] as GameCard[]
    }
  }
})
